import { render, staticRenderFns } from "./FilesEngineAttachments.vue?vue&type=template&id=4a3a99f2"
import script from "./FilesEngineAttachments.vue?vue&type=script&lang=js"
export * from "./FilesEngineAttachments.vue?vue&type=script&lang=js"
import style0 from "./FilesEngineAttachments.vue?vue&type=style&index=0&id=4a3a99f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports